<template>
  <svg
    class="voucherIcon productIcon"
    viewBox="0 0 83 90"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-miterlimit: 1.5;
    "
  >
    <rect id="Prancheta3" x="0" y="0" width="83" height="90" style="fill: none" />
    <g>
      <g>
        <path
          class="hasStroke"
          d="M9.954,54.947l3.139,-3.139"
          style="fill: none; stroke: #000; stroke-width: 3px"
        />
        <path
          class="hasStroke"
          d="M9.954,54.947l20.936,20.73l41.255,-41.46l-4.937,-4.937"
          style="fill: none; stroke: #000; stroke-width: 3px"
        />
      </g>
      <path
        class="hasStroke"
        d="M49.676,5.319l-41.46,41.461l20.936,20.731l41.255,-41.461l-20.731,-20.731"
        style="fill: none; stroke: #000; stroke-width: 3px"
      />
    </g>
    <path
      class="hasStroke"
      d="M24.673,55.381l13.784,-13.784"
      style="fill: none; stroke: #000; stroke-width: 2px; stroke-linecap: butt"
    />
    <path
      class="hasStroke"
      d="M28.085,58.793l29.691,-29.693"
      style="fill: none; stroke: #000; stroke-width: 2px; stroke-linecap: butt"
    />
  </svg>
</template>
